import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/24_bd.jpg"

const Blutmessung24 = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - 24 Stunden Blutmessung </h1>
                    <b> Auch ABDM oder Langzeitblutdruck genannt. </b>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Es kommt während des Tages zu Schwankungen des Blutdrucks, daher ist es wichtig. ein Profil des Blutdruck inklusive nächtlicher Werte zu erstellen. Diese Untersuchung ist wesentlich effizienter als Einzelmessungen und deckt auch Veränderungen des natürlichen Blutdruckverhaltens und des vegetativen Nervensystems auf. Dabei wird der Blutdruck automatisch über 24 Stunden gemessen und statistisch ausgewertet.
                        <br /> <br />
                        <b> Wann führen wir eine 24h Blutdruckmessung durch? </b>
                        <ul>
                            <li>
                                Symptome für hohen Blutdruck (Kopfschmerzen, Herzschmerzen, Nasenbluten, Atemnot etc.) bzw. 
                                niedrigen Blutdruck (Schwindel, Schwäche, Ohnmacht etc.)
                            </li>
                            <li>Schwankender Blutdruck</li>
                            <li>Verdickung der Herzwände (Linksventrikelhypertrophie)</li>
                            <li>Therapiekontrolle nach Medikationsumstellung</li>
                        </ul>
                        <b> Leider wird diese Leistung nicht von allen Kassen honoriert (Kosten: € 80.-)! </b>
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Blutmessung24;